export const sideBarWidth = '240px';
export const spHeaderHeight = '44px';
export const headerHeight = '64px';

export const cardSize = {
  '@media screen and (max-width:600px)': {
    width: '100vw'
  },
  boxShadow: 0,
  height: `calc( 100vh - ${headerHeight})`,
  width: '640px'
};

export const cardContentPadding = {
  '&:last-child': {
    '@media screen and (max-width:600px)': {
      paddingBottom: '32px'
    },
    paddingBottom: '40px'
  },
  '@media screen and (max-width:600px)': {
    padding: '24px 16px'
  },
  padding: '40px'
};

export const titleMb = {
  '@media screen and (max-width:600px)': {
    marginLeft: 0
  },
  fontSize: '22px',
  marginBottom: '24px'
};

export const textMb = {
  marginBottom: '16px'
};

export const w100 = {
  width: '100%'
};

export const formLabelWrapper = {
  fontSize: '12px',
  marginBottom: '8px'
};
